import React from 'react'
import CommonText from '../common/CommonText'
import IngredientList from './IngredientList'

const IngredientBlock = ({ children }) => {
  return (
    <>
      <CommonText fontSize="20px" tag="div" fontWeight={700}>
        {children}
      </CommonText>
      <IngredientList />
    </>
  )
}

export default IngredientBlock
